import { useAuth, useRegisterForm } from '../../context';
import { TypeUser } from '../../types/enums';
import { toCpfMask } from '../../utils/toCpfMask';
import { Container, Content } from './styles';

export function RegisterHeader() {
  const { firstName, lastName, email, document } = useRegisterForm();
  const { user } = useAuth();
  return (
    <Container>
      <Content>
        <h1>
          Olá{' '}
          <span>
            {firstName} {lastName}
          </span>
        </h1>
        <p>{email}</p>
        {user?.type === Number(TypeUser.USER) && <p>{toCpfMask(document)}</p>}
      </Content>
    </Container>
  );
}
